<template>
    <div class="animated fadeIn targetsalesform">        
        <b-card>
            <div slot="header">
                Target Collection Form
                <div class="card-header-actions">
                <button  :disabled="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="3">                            
                <b-input-group>
                    <b-input-group-prepend><label>Year Of</label></b-input-group-prepend>
                    <b-form-input v-model="model.tahun"  :state="!$v.model.tahun.$error" readonly></b-form-input>                                        
                </b-input-group>
                </b-col>
            </b-row >    
            <br>
            <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th width="250px">Sales Name</th>
                            <th style="text-align:right" width="120px">{{periode[0]}}</th>
                            <th style="text-align:right" width="120px">{{periode[1]}}</th>
                            <th style="text-align:right" width="120px">{{periode[2]}}</th>
                            <th style="text-align:right" width="120px">{{periode[3]}}</th>
                            <th style="text-align:right" width="120px">{{periode[4]}}</th>
                            <th style="text-align:right" width="120px">{{periode[5]}}</th>
                            <th style="text-align:right" width="120px">{{periode[6]}}</th>
                            <th style="text-align:right" width="120px">{{periode[7]}}</th>
                            <th style="text-align:right" width="120px">{{periode[8]}}</th>
                            <th style="text-align:right" width="120px">{{periode[9]}}</th>
                            <th style="text-align:right" width="120px">{{periode[10]}}</th>
                            <th style="text-align:right" width="120px">{{periode[11]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in budgetLines" :key="row.salesae_id">
                                <td >{{row.salesae_name}}</td>
                                <td v-if="(periodeClosed[1-1])" style="text-align:right; background:#f5f5f5;">{{row.budget1 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget1"  class="form-control text-right" style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[2-1])" style="text-align:right; background:#f5f5f5;">{{row.budget2 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget2"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[3-1])" style="text-align:right; background:#f5f5f5;">{{row.budget3 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget3"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[4-1])" style="text-align:right; background:#f5f5f5;">{{row.budget4 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0"><my-number v-model="row.budget4"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[5-1])" style="text-align:right; background:#f5f5f5;">{{row.budget5 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget5"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[6-1])" style="text-align:right; background:#f5f5f5;">{{row.budget6 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget6"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[7-1])" style="text-align:right; background:#f5f5f5;">{{row.budget7 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget7"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[8-1])" style="text-align:right; background:#f5f5f5;">{{row.budget8 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget8"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[9-1])" style="text-align:right; background:#f5f5f5;">{{row.budget9 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget9"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[10-1])" style="text-align:right; background:#f5f5f5;">{{row.budget10 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget10"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[11-1])" style="text-align:right; background:#f5f5f5;">{{row.budget11 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget11"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                                <td v-if="(periodeClosed[12-1])" style="text-align:right; background:#f5f5f5;">{{row.budget12 | numFormat}}</td>
                                <td v-else style="margin:0;padding:0;"><my-number v-model="row.budget12"  class="form-control text-right"  style="border:none;" :precision="2"></my-number></td>
                            </tr>
                            
                        </tbody>
                    </table>
            </div>                  
            <b-row class="justify-content-center mb-2">
                <button  :disabled="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
    </div>
</template>
<style lang="scss">
    .targetcollectionform {
        .report-wraper {
            width:100%;
            overflow-x: auto;
            overflow-y: auto;

            table {
                font-size: smaller;
                th {
                    border-bottom: 1px solid #D1D1D1;
                    padding: 0 15px;
                    height: 30px;
                    background: #e8e8e8;
                }              
                td {
                    border-bottom: 1px solid #e0e0e0;
                    padding: 0 10px;
                    height: 40px;
                }
                
                td.tebal {
                    font-weight: bold;
                }
                
                td.subtotal {
                    border-top: 2px solid #000 !important;
                }
                
                td.total {
                    border-top: 2px solid #000 !important;
                    background: #e6e6e6 !important;
                }
                
                td.grdtotal {
                    border-top: 2px solid #000!important;
                    border-bottom: 2px solid #000 !important;
                    background: #e6e6e6 !important;
                }
                tbody tr:hover {
                    background-color: rgba(91, 192, 222, 0.2) !important;
                    cursor: default;
                }            
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import targetsales from "../../apis/targetsales";

import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber},
  mixins: [validationMixin],
  validations: {
        model: {
            tahun: { required }
        },
  }, 
  data() {
    return {
        saveEnabled:false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        awalbln:this.$store.state.user.awalbln || 1,
        periode:['Jan ','Feb ','Mar ','Apr ','May ','Jun ','Jul ','Aug ','Sep ','Oct ','Nov ','Dec '],
        periodeClosed:[false,false,false,false,false,false,false,false,false,false,false,false],
        uanguser: this.$store.state.user.matauang,
        model:{bulan:'',tahun:''},
        budgetLines:[]    
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
        this.model.tahun=this.$route.params.tahun;
        let thn=parseInt(this.$route.params.tahun);
        let bln=parseInt(this.awalbln)-1;
        const blnaktif = this.$store.state.user.tglaktif;
        for (let index = 0; index < 12; index++) {
            bln += 1;
            if (bln>12) {
                thn += 1;
                bln = 1;
            }
            this.periode[index]=moment(`${thn}-${bln}-01`,'YYYY-MM-DD').format('MMM YYYY');
            this.periodeClosed[index]=  (moment(`${thn}-${bln}-01`,'YYYY-MM-DD').format('YYYY-MM-DD') < blnaktif);
        }
    if (this.$route.params.tahun)  {
          toastr.info('Loading Budget, please wait')
          try {
            const data = await targetsales.edit(this.$route.params);  
            this.budgetLines=data[0];
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    } 
},
  methods: {
    save: async function () {
        // if (!this.saveEnabled) {
        //     toastr.error('View mode cannot be Saved');
        //     return;
        // }
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                    const row = {};
                    row.tahun=this.model.tahun;
                    row.lines = this.budgetLines.reduce((newArr, item) => {
                        var total=item.budget1+item.budget2+item.budget3+item.budget4+item.budget5+item.budget6+item.budget7+item.budget8+item.budget9+item.budget10+item.budget11+item.budget12;
                        if (total != 0) {
                            // newArr.push({
                            //     tablekey: item.tablekey || '',
                            //     collector_id: item.collector_id,
                            //     collector_name: item.collector_name,
                            //     budget1: item.budget1,
                            //     budget2: item.budget2,
                            //     budget3: item.budget3,
                            //     budget4: item.budget4,
                            //     budget5: item.budget5,
                            //     budget6: item.budget6,
                            //     budget7: item.budget7,
                            //     budget8: item.budget8,
                            //     budget9: item.budget9,
                            //     budget10: item.budget10,
                            //     budget11: item.budget11,
                            //     budget12: item.budget12
                            // });
                            item.budget=total;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        await targetsales.save(row);
                        toastr.success("Complete successfully", "Save Budget");
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Row', 'ERROR MESSAGE');
                    }
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Budget Error");                
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'receivable.targetsalesfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'receivable.targetsales'});
          router.push({name: "sales.home"});
      }
    }
  }
};
</script>
